import _get from "lodash/get";
import { ERROR_CODE_AUTH_COGNITO } from "config/auth";
import TimeOut from "assets/image/time_out.png";
import RequestLimit from "assets/image/request_limit.png";
import DefaultError from "assets/image/input_check.png";
import dayjs from "dayjs";
import { LIST_LANGUAGE, DEFAULT_LANGUAGE } from "../i18n";
import { ERROR_STATE } from "./constants";
import Processfailed from "assets/image/processfailed.png";
import LoadFailed from "assets/image/LoadFailed.png";
import { ROUTE_BASENAME_BETA } from "config";
import { GetAuthTokenQuery, Rice, Standard } from "__generated__/graphql";
/**
 *
 * @param {Array<object>} data
 * @param {String} keyName
 * @param {String} valueName
 * @returns {Array<object>} ex. [{testA:1,testB:{testC:"1"}}],"testA","testB.testC" --> [{id:1,value:"1"}]
 */
export const convertFormatSelectOption = (data, keyName, valueName) => {
  if (data) {
    return data.map((e) => {
      const id = _get(e, keyName);
      const value = _get(e, valueName);
      return {
        id,
        value,
      };
    });
  }
  return [];
};

/**
 *
 * @param {String} type
 * @param {Array<Object>} data
 */
export const getStandard = (data) => {
  //find Standard from Key:riceID
  if (data) {
    const arr1 = data.map((item) => item.standard);
    let arrStandard = [];
    arr1.map((items) => {
      items.map((item) => {
        arrStandard.push(item);
      });
    });

    if (!arrStandard) return [];
    const arrayForSort = [...arrStandard];

    return convertFormatSelectOption(
      arrayForSort.sort(function (prve, present) {
        if (prve.isDefault > present.isDefault) return 1;
        if (prve.isDefault < present.isDefault) return -1;
        return prve.standardName.localeCompare(present.standardName, "th", {
          numeric: true,
        });
      }),
      "standardID",
      "standardName"
    );
  } else {
    return [];
  }
};
export const getStandardFromType = (data, type?: any) => {
  //find Standard from Key:riceID
  if (data) {
    const findByName = data.find((e) => e.riceID === type);
    const arr = findByName?.standard;
    if (!arr) return [];
    const arrayForSort = [...arr] as Standard[];
    // return convertFormatSelectOption(
    //   arrayForSort.sort(function (prve, present) {
    //     if (prve.isDefault > present.isDefault) return 1;
    //     if (prve.isDefault < present.isDefault) return -1;
    //     return prve.standardName.localeCompare(present.standardName, "th", {
    //       numeric: true,
    //     });
    //   }),
    //   "standardID",
    //   "standardName"
    // );
    return arrayForSort
      .sort(function (prve, present) {
        if (prve.isDefault > present.isDefault) return 1;
        if (prve.isDefault < present.isDefault) return -1;
        return prve.standardName.localeCompare(present.standardName, "th", {
          numeric: true,
        });
      })
      .map((e) => ({
        id: e.standardID,
        value: e.standardName,
        presetName: e?.presetStandard?.presetName,
      }));
  } else {
    return [];
  }
};

export function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export function isEmpty(value = null) {
  return (
    value == null ||
    (typeof value == "boolean" && value == false) ||
    (typeof value == "string" && value == "") ||
    // (typeof value == "number" && value <= 0) ||
    (typeof value == "object" && Object.keys(value).length == 0) ||
    (Array.isArray(value) && value.length == 0)
  );
}

export function isNotEmpty(value = null) {
  return !isEmpty(value);
}

export const handleViewerImage = (arr) => {
  return arr.map((e) => ({
    ["src"]: e,
    ["alt"]: e,
  }));
};

/**
 * Remove blank attributes from an Object in Javascript
 * @param {*} obj
 * https://stackoverflow.com/questions/286141/remove-blank-attributes-from-an-object-in-javascript
 */
export function removeValueEmpty(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => v != null));
}

type OmitTypename<T> = T extends { __typename: any }
  ? {
      [K in keyof T as Exclude<K, "__typename">]: T[K] extends object ? OmitTypename<T[K]> : T[K];
    }
  : T;
export const removeTypename = <T,>(obj: T): OmitTypename<T> => {
  const omitTypename = (key, value) => (key === "__typename" ? undefined : value);
  return JSON.parse(JSON.stringify(obj), omitTypename);
};

export const renderErrorMessage = (errorCode, type, t) => {
  const defaultContent = {
    type: "info",
    variant: "error",
    img: DefaultError,
  };
  switch (errorCode.code) {
    case ERROR_CODE_AUTH_COGNITO.NOT_AUTHORIZED_EXCEPTION:
      if (type === "forgotPassword")
        return {
          ...defaultContent,
          title: t("translation:login.cannot_change_password"),
        };
      else if (errorCode.message === "Invalid session for the user, session is expired.")
        return {
          ...defaultContent,
          img: TimeOut,
          title: t("translation:login.time_over"),
          description: t("translation:dialog.please_try_again"),
        };
      else
        return {
          ...defaultContent,
          description: errorCode.message,
        };
    case ERROR_CODE_AUTH_COGNITO.INVALID_PASSWORD_EXCEPTION:
      return {
        ...defaultContent,
        description: t("translation:login.password_should_be"),
      };
    // case ERROR_CODE_AUTH_COGNITO.CODE_MISMATCH_EXCEPTION:
    //   return {
    //     ...defaultContent,
    //     title: t("translation:login.incorrect_validate"),
    //   };
    case ERROR_CODE_AUTH_COGNITO.LIMIT_EXCEEDED_EXCEPTION:
      if (type === "forgotPassword")
        return {
          ...defaultContent,
          img: RequestLimit,
          title: t("translation:login.request_limit"),
          description: t("translation:login.try_again_in"),
        };
      else
        return {
          ...defaultContent,
          title: t("translation:login.over_limit"),
        };
    default:
      return {
        ...defaultContent,
        title: t("translation:dialog.cannot_process"),
        description: t("translation:dialog.check_and_tryagain"),
      };
  }
};

export const arrayDuplicateRemoveFilter = (array) => {
  return array.filter((item, index, obj) => obj.findIndex((el) => el.id === item.id) === index);
};

export const switchDataRiceInspect = (data = []) => {
  let leftData = [];
  let rightData = [];

  const even = (item, index) => index % 2 == 0;
  const odd = (item, index) => index % 2 != 0;

  leftData = data.filter(even);
  rightData = data.filter(odd);

  return { leftData, rightData };
};

export const getOriginPath = () => {
  return window.location.origin + window.location.pathname;
};

/**
 *
 * @param {Array} args
 * Ex. [{name:String,value:any}]
 * @returns test=1&test2=2
 */
export const formatSearchParam = (args = []) => {
  let params = new URLSearchParams();
  args.forEach((data) => params.set(data.name, data.value));
  return params.toString();
};

export const handleTextRiceLength = ({ conditionMin, conditionMax, minLength, maxLength }) => {
  const messageMin = (condition) => {
    if (condition == "GT") return "GT";
    if (condition == "GE") return "GE";
    return "";
  };
  const messageMax = (condition) => {
    if (condition == "LT") return "LT";
    if (condition == "LE") return "LE";
    return "";
  };
  if (conditionMin == "EQ" || conditionMax == "EQ") {
    return `EQ`;
  }
  if (minLength == 0) {
    return `${messageMax(conditionMax)}`;
  }
  if (maxLength == 99) {
    return `${messageMin(conditionMin)}`;
  }
  if (minLength && maxLength) {
    return `${messageMin(conditionMin)}${messageMax(conditionMax)}`;
  }
  return "none";
};

export const handleTextRiceLengthValue = (minLength, maxLength) => {
  return {
    valueMax: maxLength && `${maxLength}`,
    valueMin: minLength && `${minLength}`,
    value: minLength ? `${minLength}` : `${maxLength}`,
  };
};

export const putParentheses = (value, isParentheses) => (isParentheses ? `(${value})` : value);

export const mark = (operator) => {
  switch (operator) {
    case "GT":
      return "GT";
    case "LT":
      return "LT";
    case "GE":
      return "GE";
    case "LE":
      return "LE";
    case "EQ":
      return "EQ";
    case "BE":
      return "BE";
    default:
      return `none`;
  }
};

export const MathSymbol = ({ operator }) => {
  switch (operator) {
    case "GT":
      return <>&gt;</>;
    case "LT":
      return <>&lt;</>;
    case "GE":
      return <>&ge;</>;
    case "LE":
      return <>&le;</>;
    case "EQ":
      return <>=</>;
    default:
      return <></>;
  }
};

export const shareLineLink = (url, text) => {
  var left = window.screen.width / 2 - 250;
  var top = window.screen.height / 2 - 250;
  window.open(
    `https://social-plugins.line.me/lineit/share?url=${url.replace(
      ROUTE_BASENAME_BETA,
      ""
    )}&text=${text}`,
    "_blank",
    `toolbar=yes,scrollbars=yes,resizable=yes,top=${top},left=${left},width=500,height=500`
  );
};

export function downloadFileFromBlob(res, type, isNewTab = false) {
  // Convert binary to blob
  let file = new Blob([res.data], {
    type: `application/${type}`,
  });
  let fileURL = URL.createObjectURL(file);

  // Set filename
  let a = document.createElement("a");
  const contentDisposition = res.headers["content-disposition"];
  const filename = contentDisposition.split("file_name=")[1].split(";")[0];
  a.download = filename;
  if (isNewTab) {
    window.open(fileURL);
  } else {
    // Start download
    a.href = fileURL;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}

export const handleInputDatePicker = (value, language) => {
  return dayjs(value, "DD-MM-YYYY")
    .add(isBuddhistYear(language) ? -543 : 0, "year")
    .toDate();
};
export const isBuddhistYear = (language) => {
  const listUseBuddhist = ["th"];
  return listUseBuddhist.some((e) => e === language);
};

export const checkLanguage = (language) => {
  const list = LIST_LANGUAGE || [];
  const result = language ? language.split("-")[0] : DEFAULT_LANGUAGE;
  // if(!result) return DEFAULT_LANGUAGE
  if (!list.includes(result)) return DEFAULT_LANGUAGE;
  return result;
};

/**
 *
 * @returns {}
 */
export const handleMessageInspectError = ({ state, t }) => {
  let result = {
    type: "info",
    title: t("dialog.failedprocess"),
    description: t("dialog.descfailedprocess"),
    variant: "error",
    img: Processfailed,
  } as any;
  if (state === ERROR_STATE.IMAGE_ERROR) {
    result = {
      type: "info",
      title: t("error.IMAGE_ERROR.title"),
      description: t("error.IMAGE_ERROR.description"),
      variant: "error",
      img: LoadFailed,
    };
  } else if (state === ERROR_STATE.LIMIT_REACHED) {
    result = {
      type: "info",
      title: t("dialog.number_of_uses_exceeded"),
      variant: "error",
      img: LoadFailed,
    };
  }
  return result;
};

export const convertDateToStringISO = (data) => {
  if (!data) return null;
  return dayjs(data).isValid() ? dayjs(data).format() : null;
};

export const checkKeyPresenceInArray = (key, arrOfObj) => {
  if (arrOfObj === null || arrOfObj === undefined) {
    return false;
  } else {
    return arrOfObj.some((obj) => {
      if (obj === null || obj === undefined) {
        return false;
      }
      return Object.keys(obj).includes(key);
    });
  }
};

export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return "";
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
};

export const handleHeaderAuthToken = (data: GetAuthTokenQuery) => {
  return {
    Host: data.getAuthToken.Host,
    Authorization: data.getAuthToken.Authorization,
    "X-Amz-Date": data.getAuthToken.X_Amz_Date,
    // "Content-Length": data.getAuthToken.Content_Length
  };
};
